/**
 * TanStack Query mutation for saving KYC form via tRPC.
 */

import { useQueryClient } from "@tanstack/react-query";
import { kycFormDataToDbUpdates } from "../lib/kybSnake";
import { transformDBKYBToKYCFormData } from "../services/data/api/kycProvider";
import { trpc } from "../trpc";
import type { KYCFormData } from "../types";

export function useKYBSave() {
	const queryClient = useQueryClient();
	const mutation = trpc.kyb.update.useMutation({
		onSuccess: (result) => {
			const saved = transformDBKYBToKYCFormData(result);
			queryClient.setQueryData(["kyb", saved.id], saved);
			if (saved.status === "approved") {
				queryClient.invalidateQueries({ queryKey: ["wallets"] });
			}
		},
	});

	return {
		...mutation,
		mutate: (formData: KYCFormData) => {
			const updated = {
				...formData,
				lastSavedAt: new Date().toISOString(),
				updatedAt: new Date().toISOString(),
			};
			const dbUpdates = kycFormDataToDbUpdates(
				updated as unknown as Record<string, unknown>,
			);
			mutation.mutate({ id: formData.id, updates: dbUpdates });
		},
		mutateAsync: async (formData: KYCFormData) => {
			const updated = {
				...formData,
				lastSavedAt: new Date().toISOString(),
				updatedAt: new Date().toISOString(),
			};
			const dbUpdates = kycFormDataToDbUpdates(
				updated as unknown as Record<string, unknown>,
			);
			const result = await mutation.mutateAsync({
				id: formData.id,
				updates: dbUpdates,
			});
			return transformDBKYBToKYCFormData(result);
		},
	};
}
